import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";
import { registerLocale } from "react-datepicker";
import { sk } from "date-fns/locale";

function DateInput(props) {
    const { onChange, getStyle } = useChangeCheck(props.onChange);
    const {disable} = React.useContext(ChangeCheckContext);

    function handleChange(date) {
        onChange({ target: { name: props.name, value: date } });
    }

    // const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    //     <input ref={ref}
    //            name={props.name}
    //            className="form-control react-datepicker-ignore-onclickoutside"
    //            style={getStyle()}
    //            onClick={onClick}
    //            // onChange={handleInputChange}
    //            value={value}
    //            disabled={disable}
    //            autocomplete="off"
    //     />
    // ));

    registerLocale("sk", sk);

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className="mb-3">
                <DatePicker
                    name={props.name}
                    disabled={disable}
                    className="form-control react-datepicker-ignore-onclickoutside"
                    selected={Date.parse(props.value)}
                    onChange={handleChange}
                    showYearDropdown={true}
                    dropdownMode="select"
                    dateFormat="dd.MM.yyyy"
                    locale="sk"
                    // customInput={<CustomInput />}
                />
            </InputGroup>
        </>
    );
}

export default DateInput;